import React from 'react';
import { useSelector } from 'react-redux';
import styles from './Error.module.css';

const Error = () => {

  const userError = useSelector((state) => state.user.error);
  // console.log(userError);
  const chatError = useSelector((state) => state.chat.error);
  // console.log(chatError);
  const messageError = useSelector((state) => state.message.error);
  // console.log(messageError);

  const errors = [userError, chatError, messageError].filter((error) => error);

  if (errors.length === 0) return null;

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorMessage}>
        An error occured. Please refresh the page.
      </div>
    </div>
  );
};

export default Error;